import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { canUseServiceWorkers, isIOSWebView } from 'common/utils'
import { logger, ReduxActionsBridge, store } from 'services'

import '../src/app/services/i18n.ts'

import App from './App.tsx'
import TranslationsWrapper from './TranslationsWrapper'

import './index.css'
import 'react-toastify/dist/ReactToastify.css'
import '@mantine/core/styles.layer.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TranslationsWrapper>
      <App />
    </TranslationsWrapper>
  </StrictMode>,
)

// Export Redux store to window for mobile app access
if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).__REDUX_STORE__ = store
  // Create a wrapper function for dispatch to avoid minification issues
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatchWrapper = (action: any) => {
    return store.dispatch(action)
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).__REDUX_DISPATCH__ = dispatchWrapper

  // Create a store object with wrapper dispatch
  const storeWithWrapper = {
    ...store,
    dispatch: dispatchWrapper,
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).store = storeWithWrapper
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).__REDUX_ACTIONS__ = ReduxActionsBridge
}

// Check if we're in iOS WebView - if so, skip Service Worker registration
if (canUseServiceWorkers()) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js', { scope: '/' })
    .then((registration) => {
      logger.showInfoLog('Firebase Service Worker was registered on start')
      logger.showInfoLog(registration)
    })
    .catch((error) => {
      console.error('Registration of Firebase Service Worker failed:', error)
    })
} else if (isIOSWebView()) {
  console.log('Service Worker registration skipped in iOS WebView')
} else {
  console.log('Service Workers not supported in this browser')
}
